/**
 * Triggers a download of a JSON object as a file with a timestamped filename.
 * @param {Object} data - The data to save.
 * @param {string} [baseName="visualization"] - The base name for the file.
 */
export function downloadJSON(data, baseName = "visualization") {
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  const filename = `${baseName}_${timestamp}.json`;
  const jsonStr = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonStr], { type: "application/json" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 0);
}
